import { produce } from "immer";
import { mergeWithArrays } from "src/util/functions";
import { tDraftOrderAction, tDraftOrderReducerAction, tDraftOrderState } from "./types";

export const kDefaultDraftOrder: tDraftOrderState = {
  drafts: [],
  acceptDraftResults: [],
};

export const handleClearDraft = (state: tDraftOrderState = kDefaultDraftOrder): tDraftOrderState => {
  state.drafts = [];
  return state;
};

export const handleSetDraftOrder = (
  state: tDraftOrderState = kDefaultDraftOrder,
  action: tDraftOrderAction,
): tDraftOrderState => {
  return mergeWithArrays(state, "REPLACE", { drafts: action.data });
};

export const DraftOrderReducer = produce(
  (state: tDraftOrderState = kDefaultDraftOrder, action: tDraftOrderReducerAction): tDraftOrderState => {
    switch (action.type) {
      case "CLEAR_DRAFT_ORDER":
        return handleClearDraft(state);
      case "SET_DRAFT_ORDER":
        return handleSetDraftOrder(state, action);
      case "SET_DRAFT_ACCEPT_PAGE":
        state.acceptDraftResults = action.data;
        return state;
      case "CLEAR_DRAFT_ACCEPT_PAGE":
        state.acceptDraftResults = [];
        return state;
      default:
        return state;
    }
  },
);
